// A component from another part of the product, mounted on the view page
// (root-8e's estimate panel, kickoff pack, glossary): if it throws, it
// disappears on its own instead of taking the whole documentation page down
// with it - which is what an unexpected answer from its server did once.
import React from "react";

export default class Contained extends React.Component {
  constructor(props) { super(props); this.state = { failed: false }; }

  static getDerivedStateFromError() { return { failed: true }; }

  componentDidCatch(error) {
    // eslint-disable-next-line no-console
    console.warn(`[documentation] ${this.props.name || "a panel"} stopped: ${error && error.message}`);
  }

  render() { return this.state.failed ? null : this.props.children; }
}
